module.exports = __webpack_public_path__ + "static/media/Logo-TotalWorks.7988e619.png";